(function webpackUniversalModuleDefinition(root, factory) {
  if(typeof exports === 'object' && typeof module === 'object')
    module.exports = factory();
  else if(typeof define === 'function' && define.amd)
    define([], factory);
  else if(typeof exports === 'object')
    exports['chart'] = factory();
  else
    root['WaveSurfer'] = root['WaveSurfer'] || {}, root['WaveSurfer']['chart'] = factory();
})(this, function() {
  return /******/ (function(modules) { // webpackBootstrap
    /******/ 	// The module cache
    /******/ 	let installedModules = {};
    /******/
    /******/ 	// The require function
    /******/ 	function __webpack_require__(moduleId) {
      /******/
      /******/ 		// Check if module is in cache
      /******/ 		if(installedModules[moduleId]) {
        /******/ 			return installedModules[moduleId].exports;
        /******/ 		}
      /******/ 		// Create a new module (and put it into the cache)
      /******/ 		let module = installedModules[moduleId] = {
        /******/ 			i: moduleId,
        /******/ 			l: false,
        /******/ 			exports: {}
        /******/ 		};
      /******/
      /******/ 		// Execute the module function
      /******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
      /******/
      /******/ 		// Flag the module as loaded
      /******/ 		module.l = true;
      /******/
      /******/ 		// Return the exports of the module
      /******/ 		return module.exports;
      /******/ 	}
    /******/
    /******/
    /******/ 	// expose the modules object (__webpack_modules__)
    /******/ 	__webpack_require__.m = modules;
    /******/
    /******/ 	// expose the module cache
    /******/ 	__webpack_require__.c = installedModules;
    /******/
    /******/ 	// define getter function for harmony exports
    /******/ 	__webpack_require__.d = function(exports, name, getter) {
      /******/ 		if(!__webpack_require__.o(exports, name)) {
        /******/ 			Object.defineProperty(exports, name, {
          /******/ 				configurable: false,
          /******/ 				enumerable: true,
          /******/ 				get: getter
          /******/ 			});
        /******/ 		}
      /******/ 	};
    /******/
    /******/ 	// getDefaultExport function for compatibility with non-harmony modules
    /******/ 	__webpack_require__.n = function(module) {
      /******/ 		let getter = module && module.__esModule ?
        /******/ 			function getDefault() { return module['default']; } :
        /******/ 			function getModuleExports() { return module; };
      /******/ 		__webpack_require__.d(getter, 'a', getter);
      /******/ 		return getter;
      /******/ 	};
    /******/
    /******/ 	// Object.prototype.hasOwnProperty.call
    /******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
    /******/
    /******/ 	// __webpack_public_path__
    /******/ 	__webpack_require__.p = '';
    /******/
    /******/ 	// Load entry module and return exports
    /******/ 	return __webpack_require__(__webpack_require__.s = 0);
    /******/ })
  /************************************************************************/
  /******/ ([
    /* 0 */
    /***/ (function(module, __webpack_exports__, __webpack_require__) {

      'use strict';
      Object.defineProperty(__webpack_exports__, '__esModule', { value: true });
      let _createClass = function () { function defineProperties(target, props) { for (let i = 0; i < props.length; i++) { let descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

      function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

      /**
       * (Single) Chart plugin class
       *
       * Must be turned into an observer before instantiating. This is done in
       * ChartPlugin (main plugin class)
       *
       * @extends {Observer}
       */
      let Chart = function () {
        function Chart(params, ws) {
          let _this = this;

          _classCallCheck(this, Chart);

          /** This adds support for multiple canvases
           * but currently we only use one */
          this.canvases = [];

          this.wavesurfer = ws;
          this.util = ws.util;
          this.wrapper = ws.drawer.wrapper;
          this.style = ws.util.style;

          /**
           * Options argument passed to ChartJs Chart constructor.
           */
          this.chartParams = params.chart;

          /**
           * An instance of window.Chart
           * @type {Obj} See ChartJS for docs
           */
          this.chartJs = null;

          this.drawer = ws.drawer;
          this.pixelRatio = ws.drawer.params.pixelRatio;
          this.maxCanvasWidth = ws.drawer.maxCanvasWidth || ws.drawer.width;
          this.maxCanvasElementWidth = ws.drawer.maxCanvasElementWidth || Math.round(this.maxCanvasWidth / this.pixelRatio);

          this._onZoom = function () {
            // We need to briefly hide the chart so we get an accurate canvasWidth value
            _this.canvasContainer.style.display = 'none';
            let canvasWidth = _this.wrapper.scrollWidth;
            _this.canvasContainer.style.display = '';
            _this.canvasContainer.style.width = canvasWidth + 'px';
          };

          this.render();
          this.wavesurfer.on('zoom', this._onZoom); // TODO: destroy() should clean this up
          this.wavesurfer.fireEvent('chart-created', this);
        }

        _createClass(Chart, [{
          key: 'addCanvas',
          value: function addCanvas() {
            let canvasContainer = document.createElement('DIV');
            this.canvasContainer = canvasContainer;

            this.wrapper.appendChild(this.canvasContainer);

            this.util.style(this.canvasContainer, {
              width: '100%',
              height: '100%',
              position: 'relative',
              top: 0,
              left: 0,
              bottom: 0
            });

            let canvas = this.canvasContainer.appendChild(document.createElement('canvas'));
            this.canvases.push(canvas);

            this.util.style(canvas, {
              width: '100%',
              height: '100%',
              position: 'absolute',
              display: 'inline-block',
              top: 0,
              left: 0,
              bottom: 0,
              zIndex: 4
            });
            return canvas;
          }
        }, {
          key: 'removeAllCanvases',
          value: function removeAllCanvases() {
            let canvas = this.canvases.pop();

            while (canvas) {
              canvas.parentElement.removeChild(canvas);
              canvas = this.canvases.pop();
            }
          }

          /* Render a chart as a DOM element. */

        }, {
          key: 'render',
          value: function render() {
            let ctx = this.addCanvas();
            this.chartJs = new window.Chart(ctx, this.chartParams);
          }

          /* Update element's position, width, color. */

        }, {
          key: 'updateRender',
          value: function updateRender() {
            this.removeAllCanvases();
            this.render();
          }
        }]);

        return Chart;
      }();

      /**
       * @typedef {Object} ChartPluginParams
       * @property {?ChartParams[]} chart Chart that should be added upon
       * initialisation
       * `initPlugin('chart')`
       */

      /**
       * Chart are visual overlays on waveform
       * Visual customization is possible via CSS (using the selectors
       * `.wavesurfer-chart` and `.wavesurfer-handle`).
       *
       * @implements {PluginClass}
       * @extends {Observer}
       *
       * @example
       * // es6
       * import ChartPlugin from 'wavesurfer.chart.js';
       *
       * // commonjs
       * var ChartPlugin = require('wavesurfer.chart.js');
       *
       * // if you are using <script> tags
       * var ChartPlugin = window.WaveSurfer.chart;
       *
       * // ... initialising wavesurfer with the plugin
       * var wavesurfer = WaveSurfer.create({
 *   // wavesurfer options ...
 *   plugins: [
 *     ChartPlugin.create({
 *       // plugin options ...
 *     })
 *   ]
 * });
       */


      let ChartPlugin = function () {
        _createClass(ChartPlugin, null, [{
          key: 'create',

          /**
           * Chart plugin definition factory
           *
           * This function must be used to create a plugin definition which can be
           * used by wavesurfer to correctly instantiate the plugin.
           *
           * @param {ChartPluginParams} params parameters use to initialise the plugin
           * @return {PluginDefinition} an object representing the plugin
           */
          value: function create(params) {
            return {
              name: 'chart',
              deferInit: params && params.deferInit ? params.deferInit : false,
              params: params,
              staticProps: {
                addChart: function addChart(options) {
                  if (!this.initialisedPluginList.chart) {
                    this.initPlugin('chart');
                  }
                  return this.chart.add(options);
                },


                /**
                 * Used to add a dataset to an existing chart. This enables you to plot multiple line graphs at one time.
                 * @param {object} dataset ChartJS dataset JSON object
                 * @returns {boolean}
                 */
                addDataset: function addDataset(dataset) {
                  let chart = this.chart.chart.chartJs;

                  let i = void 0;
                  for (i = 0; i < chart.data.datasets.length; i++) {
                    if (chart.data.datasets[i].label === dataset.label) {
                      return true; // Don't duplicate an existing dataset
                    }
                  }

                  // Show the canvas, if needed
                  if (this.chart.chart.canvasContainer.style.display === 'none') {
                    this.chart.chart.canvasContainer.style.display = '';
                  }

                  // Finally, add the new dataset and re-render
                  chart.data.datasets.push(dataset);
                  return chart.update();
                },


                /**
                 * Removes the specified dataset from the currently displayed chart and re-renders the chart so it will no
                 * longer display.
                 * @param {string} label Label of the dataset you want removed.
                 * @param {boolean} hideChartOnEmpty If true, the ChartJS canvas will be hidden if the dataset being removed was
                 * the last dataset left.
                 * @returns {boolean}
                 */
                removeDataset: function removeDataset(label, hideChartOnEmpty) {
                  let chart = this.chart && this.chart.chart && this.chart.chart.chartJs ? this.chart.chart.chartJs : false;
                  if (!chart) {
                    return false;
                  }

                  let i = void 0,
                    datasetFound = false;

                  for (i = 0; i < chart.data.datasets.length; i++) {
                    if (chart.data.datasets[i].label === label) {
                      datasetFound = true;
                      break;
                    }
                  }

                  if (datasetFound) {
                    chart.data.datasets.splice(i, 1);

                    if (hideChartOnEmpty && chart.data.datasets.length === 0) {
                      this.chart.chart.canvasContainer.style.display = 'none';
                    }
                    return chart.update();
                  }
                },


                /**
                 * Getter for the chart
                 * @returns {Object}
                 */
                getChart: function getChart() {
                  return this.chart.chart;
                }
              },
              instance: ChartPlugin
            };
          }
        }]);

        function ChartPlugin(params, ws) {
          let _this2 = this;

          _classCallCheck(this, ChartPlugin);

          this.params = params;
          this.wavesurfer = ws;
          this.util = ws.util;
          // Always track the current chart
          this.chart = null;

          // turn the plugin instance into an observer
          let observerPrototypeKeys = Object.getOwnPropertyNames(this.util.Observer.prototype);
          observerPrototypeKeys.forEach(function (key) {
            Chart.prototype[key] = _this2.util.Observer.prototype[key];
          });
          this.wavesurfer.Chart = Chart;

          this._onReady = function () {
            _this2.wrapper = _this2.wavesurfer.drawer.wrapper;
            if (_this2.params.chart) {
              _this2.params.chart.forEach(function (chart) {
                _this2.add(chart);
              });
            }
          };
        }

        _createClass(ChartPlugin, [{
          key: 'init',
          value: function init() {
            // Check if ws is ready
            if (this.wavesurfer.isReady) {
              this._onReady();
            }
            this.wavesurfer.on('ready', this._onReady);
          }
        }, {
          key: 'destroy',
          value: function destroy() {
            this.wavesurfer.un('ready', this._onReady);
            if (this.clear) this.clear();
          }

          /**
           * Add a Chart to Wavesurfer
           * @param params ChartJS formatted params
           * @returns {*|Chart}
           */

        }, {
          key: 'add',
          value: function add(params) {
            let _this3 = this;

            let chart = new this.wavesurfer.Chart(params, this.wavesurfer);

            this.chart = chart;

            chart.on('remove', function () {
              _this3.chart = null;
            });

            return chart;
          }
        }]);

        return ChartPlugin;
      }();

      /* harmony default export */ __webpack_exports__['default'] = (ChartPlugin);

      /***/ })
    /******/ ]);
});
